<template>
  <v-container>
    <v-card class="mx-auto opacity-background pa-8" max-width="650">
      <v-form ref="form" lazy-validation>
        <v-text-field v-model="userData.name" :label="$t('name')" :rules="rules"></v-text-field>
        <v-text-field v-model="userData.email" :label="$t('email')" disabled></v-text-field>
        <v-text-field v-model="permission" :label="$t('permission')" disabled></v-text-field>
        <v-text-field v-model="userData.phone" :label="$t('phone')" :rules="rules"></v-text-field>
        <v-text-field v-model="userData.address" :label="$t('address')" :rules="rules"></v-text-field>
        <v-text-field v-model="userData.profession" :label="$t('profession')" :rules="rules"></v-text-field>
        <v-text-field v-model="userData.department" :label="$t('department')" :rules="developerRules"></v-text-field>
        <v-text-field v-model="userData.taxId" :label="$t('taxId')" :rules="developerRules"></v-text-field>
        <v-select :label="$t('industrys')" :items="industryItems" v-model="userData.industrys" :rules="rules" :disabled="isDeveloper"></v-select>
        <v-file-input v-model="avatarFile" :label="$t('avatar')" prepend-icon="" prepend-inner-icon="mdi-paperclip"></v-file-input>
        <template v-if="isOauth">
          <a href="https://hackmd.io/@iMacloud/rJjtTpBI2" target="_blank" rel="noopener">TOTP{{$t('description')}}</a>
          <v-switch v-model="totpStatus" :label="$t('enableTotp')" @change="confirmTotp()"></v-switch>
          <v-row v-if="isSetTotp" align="center" class="_grey--text">
            <v-col cols="3"><QrcodeVue :value="qrcodeStr"></QrcodeVue></v-col>
            <v-col cols="7">
              <v-row>
                <div>{{ $t('inputOtp') }}</div>
              </v-row>
              <v-row>
                <div class="position-relative" style="max-width: 300px">
                  <v-otp-input v-model="otpValue" plain></v-otp-input>
                </div>
              </v-row>
            </v-col>
            <v-col cols="2">
              <v-btn @click="verifyTotp()">{{ $t('verify') }}</v-btn>
            </v-col>
          </v-row>
        </template>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="_blue" outlined text @click="$router.go(-1)">{{ $t('cancel') }}</v-btn>
        <v-btn color="_blue" class="white--text" @click="modifyData()">{{ $t('ok') }}</v-btn>
      </v-card-actions>
    </v-card>
    <Dialog :isShow="confirmDialog" title="cancel" msg="confirmMsg" verbMsg="cancel" @confirm="enableTotp()" @cancel="confirmCancel()" />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import QrcodeVue from 'qrcode.vue';
import CommVar from '@/method/commVar';
import S3 from '@/api/awsS3';
import User from '../store/user';
import Dialog from '../components/Dialog.vue';

export default {
  name: 'userAttribute',
  props: { form: { type: String, default: 'signIn' } },
  components: { QrcodeVue, Dialog },
  data: () => ({
    avatarFile: [],
    otpLoading: false,
    totpStatus: false,
    isSetTotp: false,
    qrcodeStr: '',
    otpValue: '',
    confirmDialog: false,
  }),
  computed: {
    ...mapState('authenticate', ['isSignIn', 'userAttribute']),
    ...mapState('dbTable', ['permissionList']),
    ...mapGetters('dbTable', ['industryList', 'permissionId']),
    permission() {
      if (!this.isSignIn) return [];
      const items = ['launch', 'audit', 'download', 'usage', 'basicStatistics', 'basicQuery'];
      const ary = [];
      items.forEach((x) => {
        if (Object.keys(this.userData.policy).findIndex((y) => this.permissionId(x) === y) !== -1) {
          ary.push(this.$t(x));
        }
      });
      return ary;
    },
    rules() {
      return [(v) => !!v || this.$t('require')];
    },
    developerRules() {
      return [(v) => this.isDeveloper || !!v || this.$t('require')];
    },
    isDeveloper() {
      if (!this.isSignIn) return false;
      return Object.keys(this.userAttribute.policy).findIndex((x) => x === this.permissionId('launch')) !== -1;
    },
    isOauth() {
      // return window.sessionStorage.getItem('isOauthTest') === 'true';// CHERRY_TEST
      return process.env.VUE_APP_SSO === 'oauth2';// CHERRY_TEST
    },
    industryItems() {
      if (!this.industryList) return [];
      const ary = this.industryList.map((x) => ({ text: x.name, value: x.id }));
      ary.unshift({ text: 'All', value: 'All' });
      return ary;
    },
    userData() {
      if (!this.isSignIn) return {};
      return { ...this.userAttribute };
    },
  },
  created() {
    if (!this.isSignIn) this.$router.push({ name: 'account' });
    if (!this.isOauth) return;
    this.$store.commit('loading/start', { text: 'working' });
    this.$store
      .dispatch('authenticate/oauthToken', { refreshToken: window.localStorage.getItem('oauthRefreshToken') })
      .then((result) => {
        this.$store.commit('authenticate/setUserAccessToken', result.accessToken);
        this.$store
          .dispatch('authenticate/totpStatus')
          .then((status) => {
            this.totpStatus = status;
            console.log('totp status', this.totpStatus);
            this.$store.commit('loading/stop');
          })
          .catch(() => {
            this.totpStatus = false;
            this.$store.commit('loading/stop');
          });
      })
      .catch(() => {
        this.$store.commit('loading/stop');
        this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errLoginExpired')] });
        window.localStorage.removeItem('oauthRefreshToken');
        window.localStorage.removeItem('oauthCode');
      });
  },
  methods: {
    isTotp() {
      this.$store
        .dispatch('authenticate/totpStatus')
        .then((result) => {
          this.totpStatus = result;
          console.log('totp status', this.totpStatus);
        })
        .catch(() => {
          this.totpStatus = false;
        });
    },
    confirmTotp() {
      if (this.totpStatus) {
        this.enableTotp();
      } else {
        this.confirmDialog = true;
      }
    },
    confirmCancel() {
      this.confirmDialog = false;
      this.totpStatus = true;
    },
    enableTotp() {
      this.confirmDialog = false;
      this.$store.commit('loading/start', { text: 'working' });
      this.$store
        .dispatch('authenticate/totpEnable', { enable: this.totpStatus })
        .then((result) => {
          this.isSetTotp = this.totpStatus;
          this.$store.commit('loading/stop');
          console.log(result);
          if (this.totpStatus) {
            const user = encodeURIComponent(this.userAttribute.email);
            this.qrcodeStr = `otpauth://totp/${encodeURIComponent('iMacloud OTP')}:${user}?secret=${result}&issuer=ITRI`;
          } else {
            this.qrcodeStr = '';
            this.$store.commit('notify/set', { type: 'success', msg: [this.$t('close'), ' ', this.$t('success')] });
          }
        })
        .catch(() => {
          this.totpStatus = false;
          this.isSetTotp = false;
          this.qrcodeStr = '';
          this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errLoginExpired')] });
          this.$store.commit('loading/stop');
        });
    },
    verifyTotp() {
      if (this.otpValue === '') {
        this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errVerifyCode')] });
        return;
      }
      this.$store
        .dispatch('authenticate/totpVerify', { code: this.otpValue })
        .then((result) => {
          this.otpValue = '';
          if (result.status === 'fail') {
            this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errVerifyCode')] });
          } else {
            this.$store.commit('notify/set', { type: 'success', msg: [this.$t('verify'), ' ', this.$t('success')] });
            this.isSetTotp = false;
            this.isTotp();
          }
        })
        .catch((err) => {
          console.log(err);
          this.otpValue = '';
          this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errVerifyCode')] });
        });
    },
    modifyData() {
      if (!this.$refs.form.validate()) return;
      this.$store.commit('loading/start', { text: 'working' });
      if (this.avatarFile.length !== 0) {
        let fileName;
        if (Object.prototype.hasOwnProperty.call(this.userData, 'avatar') && this.userData.avatar.type === 'image') {
          fileName = `${this.userData.avatar.path}`;
        } else {
          fileName = `${CommVar.randomId()}.jpg`;
        }
        this.userData.avatar = { type: 'image', path: fileName };
        S3.upload(`public/avatar/${this.userData.avatar.path}`, this.avatarFile);
      }
      User.update(this.userData)
        .then(() => {
          this.$store.commit('authenticate/setUserAttribute', this.userData);
          this.$store.commit('loading/stop');
          this.$store.commit('notify/set', { type: 'success', msg: [this.$t('modify'), ' ', this.$t('success')] });
          this.$router.push({ name: 'main' });
        })
        .catch((error) => {
          this.$store.commit('loading/stop');
          this.$store.commit('notify/set', { type: 'alarm', msg: [error] });
        });
    },
    fileExtension(fileName) {
      return /[.]/.exec(fileName) ? /[^.]+$/.exec(fileName)[0] : '';
    },
  },
};
</script>

<style scoped>
.opacity-background {
  background-color: rgba(255, 255, 255, 0.75) !important;
}
</style>
